/**
 * NosAKLayout — Wraps all Nosak pages with TopBar + ActionStrip.
 * Provides the global executive operating system context.
 */
import React from "react";
import { Outlet } from "react-router-dom";
import NosAKTopBar from "@/components/NosAKTopBar";
import NosAKActionStrip from "@/components/NosAKActionStrip";

export default function NosAKLayout() {
  return (
    <div className="flex flex-col h-full">
      <NosAKTopBar />
      <NosAKActionStrip />
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
